__webpack_require__.p = "https://tools.regiosuisse.ch/embed/regions/";